'use client';
import { useRef } from 'react';
import { useIsomorphicEffect } from '../useIsomorphicEffect/useIsomorphicEffect.js';

var useLatestRef = function(value) {
    var ref = useRef(value);
    useIsomorphicEffect(function() {
        ref.current = value;
    });
    return ref;
};

export { useLatestRef };
